import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ContactForm from "./sections/ContactForm";
import WhatsAppButton from "./sections/WhatsAppButton";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ContactForm />
      <WhatsAppButton />
      <Footer />
    </div>;
}